import React from 'react';
import { Box, Typography } from '@material-ui/core';

import HttpCardList from 'src/components/HttpCardList';
import Label from 'src/components/Label';
import Card from 'src/components/Card';

import RoleForm from '../RoleForm';
import RoleMiniCard from '../../../../components/miniCards/RoleMiniCard';

const RolesCardList = ({
  workflowId
}: { workflowId: string }) => (
  <HttpCardList
    url={`/automatic/workflows/${workflowId}/roles/`}
    objectType="role"
    CardComponent={({ item }: any) => <RoleMiniCard role={item} />}
    FormComponent={RoleForm}
    formProps={{ workflowId }}
  />
);

export default RolesCardList;
